class Katapult {
    constructor() {
        if (
            typeof Settings.services['katapult'] !== 'undefined' &&
            Settings.services['katapult']['enabled'] === true
        ) {
            this.katapult = window['zibby'] || (window['zibby'] = []);
            this.isEnabled = true;
        } else {
            this.katapult = [];
            this.isEnabled = false;
        }
    }

    preapprove() {
        if (!this.isEnabled) {
            return console.log('Katapult is not enabled.');
        }

        try {
            this.katapult.preapprove();
        } catch (error) {
            console.log(error);
        }
    }
}

export default new Katapult();
